import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PortalRenderDirective } from './portal-render.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PortalRenderDirective],
  exports: [PortalRenderDirective],
})
export class PortalRenderModule {}
